const ORDINAL_SUFFIXES: Readonly<Record<number, string>> = {1: 'st', 2: 'nd', 3: 'rd'};
const ORDINAL_TEEN_DAYS: readonly number[] = [11, 12, 13];
const DECIMAL_BASE = 10;

export const getEnglishOrdinal = (day: number) => {
  const suffix = ORDINAL_TEEN_DAYS.includes(day)
    ? 'th'
    : (ORDINAL_SUFFIXES[day % DECIMAL_BASE] ?? 'th');
  return `${day}${suffix}`;
};
